// extracted by mini-css-extract-plugin
export default {"sliderButtons":"SliderButtons_sliderButtons__6HXEV","button":"SliderButtons_button__Qjo14","btnRight":"SliderButtons_btnRight__qH1x9"};